import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export const BlueGPSIcon = ({ ariaLabel = 'GPS icon', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}

      <rect x="0.121094" y="0.467529" width="32" height="32" rx="16" fill="#E9F8FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.46862 15.7883C7.62003 16.1902 7.74323 17.4344 8.65417 17.6621L13.1452 18.7849C13.4695 18.866 13.7227 19.1192 13.8038 19.4435L14.9266 23.9346C15.1543 24.8455 16.3985 24.9687 16.8005 24.1201L23.1005 10.8201C23.5027 9.9709 22.6178 9.08601 21.7687 9.48825L8.46862 15.7883Z"
        fill="#0091D3"
      />
    </svg>
  );
};
